import axios from 'axios';
import { API_URL } from '../../lib/const';

export const fetchFaq = () => (
  axios.get(`${API_URL}/faq/questions`)
    .then(response => response.data)
);

export default fetchFaq;
